import axios from 'axios';
import {
    COHORT_LIST_REQUEST, COHORT_LIST_SUCCESS, COHORT_LIST_FAIL,
    COHORT_LIST_BY_IDS_REQUEST, COHORT_LIST_BY_IDS_SUCCESS, COHORT_LIST_BY_IDS_FAIL,
    COHORT_DETAILS_REQUEST, COHORT_DETAILS_SUCCESS, COHORT_DETAILS_FAIL,
    COHORT_CREATE_REQUEST, COHORT_CREATE_SUCCESS, COHORT_CREATE_FAIL,
    COHORT_UPDATE_REQUEST, COHORT_UPDATE_SUCCESS, COHORT_UPDATE_FAIL,
    COHORT_DELETE_REQUEST, COHORT_DELETE_SUCCESS, COHORT_DELETE_FAIL,
    COHORT_DTO_REQUEST, COHORT_DTO_SUCCESS, COHORT_DTO_FAIL,
    COHORT_SEND_COHORT_REQUEST, COHORT_SEND_COHORT_SUCCESS, COHORT_SEND_COHORT_FAIL,
} from '../constants/cohortConstants';
import { formatApiError } from '../utils/formatApiError';

// Helper functions
const getAuthConfig = (token) => ({
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
});

const formatErrorMessage = (error) => {
    if (error.response?.status === 403) {
        return [formatApiError(error)];
    }
    const errorMessages = [];
    if (error.response?.data) {
        if (error.response.data.errors) {
            Object.entries(error.response.data.errors).forEach(([key, value]) => {
                errorMessages.push(`${key}: ${value[0]}`);
            });
        }
        if (error.response.data.detail) {
            errorMessages.push(`Detail: ${error.response.data.detail}`);
        }
        if (error.response.data.message) {
            errorMessages.push(`Message: ${error.response.data.message}`);
        }
    }
    return errorMessages.length > 0 ? errorMessages : [error.message || "An error occurred, please try again later"];
};

const API_BASE_URL = '/dotnet_api/v1/cohort';

export const listCohorts = (params = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: COHORT_LIST_REQUEST });
        const config = {
            ...getAuthConfig(getState().userLogin.userInfo.token),
            params
        };
        const { data } = await axios.get(`${API_BASE_URL}/all`, config);
        dispatch({ type: COHORT_LIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: COHORT_LIST_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const listCohortsByIds = (ids) => async (dispatch, getState) => {
    try {
        dispatch({ type: COHORT_LIST_BY_IDS_REQUEST });
        const { data } = await axios.post(
            `${API_BASE_URL}/ids/all`,
            ids,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: COHORT_LIST_BY_IDS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: COHORT_LIST_BY_IDS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getCohortDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: COHORT_DETAILS_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: COHORT_DETAILS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: COHORT_DETAILS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const createCohort = (cohortData) => async (dispatch, getState) => {
    try {
        dispatch({ type: COHORT_CREATE_REQUEST });
        const { data } = await axios.post(
            API_BASE_URL,
            cohortData,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: COHORT_CREATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: COHORT_CREATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const updateCohort = (id, changes) => async (dispatch, getState) => {
    try {
        dispatch({ type: COHORT_UPDATE_REQUEST });
        const { data } = await axios.patch(
            `${API_BASE_URL}/${id}`,
            changes,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: COHORT_UPDATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: COHORT_UPDATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const deleteCohort = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: COHORT_DELETE_REQUEST });
        await axios.delete(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: COHORT_DELETE_SUCCESS });
    } catch (error) {
        dispatch({ type: COHORT_DELETE_FAIL, payload: formatErrorMessage(error) });
    }
};

export const loadCohortDto = () => async (dispatch, getState) => {
    try {
        dispatch({ type: COHORT_DTO_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/dto`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: COHORT_DTO_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: COHORT_DTO_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const sendCohort = (cohortId) => async (dispatch, getState) => {
    try {
        dispatch({ type: COHORT_SEND_COHORT_REQUEST });
        const { data } = await axios.patch(
            `${API_BASE_URL}/${cohortId}/send-cohort`,
            {},
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: COHORT_SEND_COHORT_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: COHORT_SEND_COHORT_FAIL,
            payload: formatErrorMessage(error)
        });
    }
}; 